<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
				<div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
					<BackLink/>
				</div>
        <Form
          :data="form"
          :detailsTitle="question.detailsTitle"
          :detailsMessage="question.detailsMessage"
          :formId="question.id"
          :formErrorMessage="errorMessage"
          :submitButtonText="submitButtonText"
          @submit="submitStatement"
        >
          <div class="form-group">
            <fieldset class="fieldset" :aria-describedby="getId">
              <legend class="fieldset__legend fieldset__legend--xl">
                <h1>{{question.question}}</h1>
              </legend>
              <div class="wysiwyg" :id="getId" v-if="question.hintText != null" v-html="question.hintText"></div>
              <slot></slot>
            </fieldset>
          </div>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "Statement",
  props: {
    title: String
  },
  data() {
    return {
      selected: null,
      question: {},
      getId: this.question.id + "-hint",
      errorMessage: "All fields are required",
      submitButtonText: "",
      form: {}
    };
  },
  created() {
    this.loadQuestion();
    // setTimeout(()=>{
    //   this.redirectToTimeout()
    // },1200000);
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.question = currentQuestion;
      this.$summaryAvailable = true;
    },
    submitStatement() {
      if (this.question.destination.indexOf('https') > -1) {
        window.location.href = this.question.destination;
      } else {
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.question.destination.toLowerCase() });
            }
      }
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>